(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach(
            (el) => {
              [...el.classList]
                .filter((cl) => cl.indexOf('disclosure') === 0)
                .forEach((cl) => {
                  el.classList.remove(cl);
                  el.classList.add(`mobile-${cl}`);
                });
            }
          );
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll(
            '.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content'
          ).forEach((el) => {
            [...el.classList]
              .filter((cl) => cl.indexOf('mobile-disclosure') === 0)
              .forEach((cl) => {
                el.classList.remove(cl);
                el.classList.add(cl.substr(7));
              });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-recent-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORAGE_KEY = 'mk-recently-viewed';
  var MAX_STORED = 12;

  function getIds() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var ids = raw ? JSON.parse(raw) : [];
      return Array.isArray(ids) ? ids.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function setIds(ids) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(0, MAX_STORED)));
    } catch (e) {}
  }

  function recordId(productId) {
    if (!productId) return;
    var id = String(productId);
    var ids = getIds().filter(function (item) {
      return item !== id;
    });
    ids.unshift(id);
    setIds(ids);
  }

  function clearIds() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function getShopifySection(section) {
    return section ? section.closest('.shopify-section') : null;
  }

  function hideSection(section) {
    if (!section) return;
    section.hidden = true;
    section.setAttribute('hidden', '');
    var shopifySection = getShopifySection(section);
    if (shopifySection) {
      shopifySection.hidden = true;
      shopifySection.setAttribute('hidden', '');
      shopifySection.style.display = 'none';
    }
    var grid = section.querySelector('[data-recent-grid]');
    if (grid) grid.innerHTML = '';
  }

  function showSection(section) {
    if (!section) return;
    section.hidden = false;
    section.removeAttribute('hidden');
    var shopifySection = getShopifySection(section);
    if (shopifySection) {
      shopifySection.hidden = false;
      shopifySection.removeAttribute('hidden');
      shopifySection.style.display = '';
    }
  }

  function reorderGrid(grid, orderedIds) {
    var blocks = Array.prototype.slice.call(grid.querySelectorAll('[data-product-id]'));
    if (!blocks.length) return;
    var map = {};
    blocks.forEach(function (block) {
      map[String(block.getAttribute('data-product-id'))] = block.closest('.slider__item') || block;
    });
    orderedIds.forEach(function (id) {
      if (map[id]) grid.appendChild(map[id]);
    });
  }

  function refreshCarousel(section) {
    var carousel = section && section.querySelector('carousel-slider');
    if (carousel && typeof carousel.refresh === 'function') {
      carousel.refresh();
    }
  }

  function loadRecentProducts(section) {
    if (!section || section.dataset.recentLoaded === 'true') return;

    var currentId = section.dataset.productId ? String(section.dataset.productId) : '';
    if (currentId) recordId(currentId);

    var limit = parseInt(section.dataset.limit, 10) || 4;
    var ids = getIds().filter(function (id) {
      return id !== currentId;
    }).slice(0, limit);

    if (!ids.length) {
      // Theme editor: keep placeholders visible for editing
      if (window.Shopify && window.Shopify.designMode) {
        showSection(section);
        refreshCarousel(section);
      } else {
        hideSection(section);
      }
      return;
    }

    var searchUrl = section.dataset.searchUrl || '/search';
    var query = ids.map(function (id) {
      return 'id:' + id;
    }).join(' OR ');
    var url = searchUrl + '?type=product&q=' + encodeURIComponent(query) + '&section_id=' + encodeURIComponent(section.dataset.sectionId);

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = document.createElement('div');
        doc.innerHTML = html;
        var fetched = doc.querySelector('.mk-recent-products');
        var fetchedGrid = fetched && fetched.querySelector('[data-recent-grid]');
        var grid = section.querySelector('[data-recent-grid]');
        if (!fetchedGrid || !grid || !fetchedGrid.children.length) {
          hideSection(section);
          return;
        }

        grid.innerHTML = fetchedGrid.innerHTML;
        reorderGrid(grid, ids);
        showSection(section);
        section.dataset.recentLoaded = 'true';
        refreshCarousel(section);
      })
      .catch(function () {
        hideSection(section);
      });
  }

  function initSection(section) {
    if (!section) return;

    // Default: hide entire section until recent products are confirmed
    if (!(window.Shopify && window.Shopify.designMode)) {
      hideSection(section);
    } else {
      section.classList.add('mk-recent-products--design-mode');
      showSection(section);
    }

    var clearBtn = section.querySelector('[data-recent-clear]');
    if (clearBtn && clearBtn.dataset.bound !== 'true') {
      clearBtn.dataset.bound = 'true';
      clearBtn.addEventListener('click', function (evt) {
        evt.preventDefault();
        clearIds();
        hideSection(section);
        section.dataset.recentLoaded = 'false';
      });
    }

    loadRecentProducts(section);
  }

  function initAll() {
    document.querySelectorAll('.mk-recent-products').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = document.querySelector(
      '.mk-recent-products[data-section-id="' + event.detail.sectionId + '"]'
    );
    if (section) {
      section.dataset.recentLoaded = 'false';
      initSection(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
